module.exports = __webpack_public_path__ + "assets/img/textUnderstanding.e176ce2d.png";